module.exports = __webpack_public_path__ + "img/27_71.c83ed811.png";